export default "__VITE_ASSET__E_AnvRXs__"